export default (state, { payload: { id } }) => ({
  ...state,
  items: [
    ...state.items.map(item =>
      item.id === id
        ? {
            ...item,
            isVariantInStock: false,
            variants: item.variants.map(variant =>
              variant.id === item.variantId
                ? { ...variant, isVariantInStock: false }
                : variant
            ),
            isProductInStock: item.variants.some(
              variant =>
                variant.isVariantInStock && item.variantId !== variant.id
            )
          }
        : item
    )
  ]
});
